import React, { useRef, useState, useEffect } from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import "./ChallanForm.css";
import "./Form.css";
import { consigneeStationMasterApiConfig } from "../config/apiConfig.js";
import {
  dataObject,
  validate,
  popupInfo,
  consigneeStationTableHeader,
  consigneeStationTableItems,
} from "../config/ConsigneeStationMaster";

import LoadingOverlay from "react-loading-overlay";
import Autosuggest from "react-autosuggest";
import "./AutoSuggest.css";
import useForm from "./useForm";
import { SERVER_URL } from "../config/config";

const ConsigneeStationMasterForm = ({
  sessionObject,
  initialConsignorId,
  initialConsignorName,
  initialConsigneeId,
  initialConsigneeName,
  initialConsigneeGst,
  onSaved,
}) => {
  let variablesFromSession = {
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
  };

  const myForm = useForm(
    "CONSIGNEESTATIONMASTER",
    validate,
    { ...dataObject, ...variablesFromSession },
    consigneeStationMasterApiConfig,
  );

  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  const selectedConsignorIdRef = useRef("");
  const [tableSearch, setTableSearch] = useState("");
  const consignorOptions = [
    {
      id: "279905",
      name: "R R KABEL LIMITED-ASL(SWITCH)",
      gst: "24AABCR3352C1ZX",
    },
    {
      id: "768",
      name: "R R KABEL LIMITED-ASL.",
      gst: "24AABCR3352C1ZX",
    },
  ];
  const editingRateInfoIndexRef = useRef(null);
  const consigneeFetchRef = useRef(0);

  const getConsignorId = () =>
    selectedConsignorIdRef.current || myForm.pageState.consignor_id;

  const fetchStationToMapByConsignor = async (consignorId) => {
    const cId = consignorId || getConsignorId();
    if (cId == "" || cId == null) {
      myForm.setPageMode("error");
      myForm.setPopupError("Select a valid Consignor first");
      return;
    }
    consigneeFetchRef.current = 0;
    myForm.setPageStateByField("consignee_fetch", 0);
    myForm.setOverlay(true);
    const url = SERVER_URL + "/station_to_map?consignor_id=" + String(cId);

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        myForm.setPageMode("error");
        myForm.setPopupError("Failed to fetch station mappings");
        return;
      }
      const resp = await response.json();
      myForm.setPageStateByField("rate_info", Array.isArray(resp) ? resp : []);
      setTableSearch("");
    } catch (err) {
      console.log("Error in station_to_map fetch", err);
      myForm.setPageMode("error");
      myForm.setPopupError("Failed to fetch station mappings");
    } finally {
      myForm.setOverlay(false);
    }
  };

  const fetchStationToMapByConsignee = async (consigneeId) => {
    const cgId =
      consigneeId || myForm.pageState.consignee || myForm.pageState.consignee_id;
    if (cgId == "" || cgId == null) {
      myForm.setPageMode("error");
      myForm.setPopupError("Select a valid Consignee first");
      return;
    }
    consigneeFetchRef.current = 1;
    myForm.setPageStateByField("consignee_fetch", 1);
    myForm.setOverlay(true);
    const url = SERVER_URL + "/station_to_map?consignee_id=" + String(cgId);

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        myForm.setPageMode("error");
        myForm.setPopupError("Failed to fetch station mappings");
        return;
      }
      const resp = await response.json();
      myForm.setPageStateByField("rate_info", Array.isArray(resp) ? resp : []);
      setTableSearch("");
      myForm.makeFocusOnParticularField("consignee_gst");
    } catch (err) {
      console.log("Error in station_to_map fetch", err);
      myForm.setPageMode("error");
      myForm.setPopupError("Failed to fetch station mappings");
    } finally {
      myForm.setOverlay(false);
    }
  };

  const getConsigneeStation = async (e) => {
    if (e.key == "Enter") {
      // Fetch by consignee id and override earlier consignor data
      const consigneeId =
        myForm.pageState.consignee || myForm.pageState.consignee_id;
      if (consigneeId == "" || consigneeId == null) {
        // Fallback to consignor flow if consignee not selected
        const consignorId = getConsignorId();
        if (consignorId == "" || consignorId == null) {
          myForm.setPageMode("error");
          myForm.setPopupError("Select a valid Consignor or Consignee first");
          return;
        }
        await fetchStationToMapByConsignor(consignorId);
        myForm.makeFocusOnParticularField("consignee_gst");
        return;
      }
      await fetchStationToMapByConsignee(consigneeId);
    }
  };

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const consignorId = initialConsignorId || params.get("consignor_id");
      const consignorName =
        initialConsignorName || params.get("consignor_name");
      if (consignorId || consignorName) {
        if (consignorId) {
          selectedConsignorIdRef.current = consignorId;
          myForm.setPageStateByField("consignor_id", consignorId);
        }
      if (consignorName) {
        myForm.setPageStateByField("consignor_name", consignorName);
      }
      if (initialConsigneeId) {
        myForm.setPageStateByField("consignee", initialConsigneeId);
      }
      if (initialConsigneeName) {
        myForm.setPageStateByField("consignee_name", initialConsigneeName);
      }
      if (initialConsigneeGst) {
        myForm.setPageStateByField("consignee_gst", initialConsigneeGst);
      }
        if (consignorId) {
          const fakeEvent = { key: "Enter" };
          getConsigneeStation(fakeEvent);
        }
      }
    } catch (e) {}
    setTimeout(() => {
      try {
        myForm.makeFocusOnParticularField("consignor_name");
      } catch (e) {}
    }, 0);
  }, []);

  let consignorNameFieldInfo = {
    label: "Consignor Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignor_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsignorSuggestions",
    url: SERVER_URL + "/consignor/",
    suggestionKeyword: "consignor_name",
    suggestionKeywordExtra: "consignor_gst",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "consignor_id",
    apiCallRequiredOnGetValue: true,
    suggestionSchema: {
      consignor_name: "consignor_name",
      consignor_id: "consignor_id",
    },
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
      Enter: "consignee_name",
    },
    idClearanceNeeded: "consignor_id",
  };

  let stationToFieldInfo = {
    label: "Station To",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "station_to_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getCitySuggestions",
    url: SERVER_URL + "/branch/",
    suggestionKeyword: "name",
    suggestionKeywordForFetchApiArgs: "name",
    suggestionChooseQueryKeyword: "branch_id",
    apiCallRequiredOnGetValue: true,
    suggestionSchema: {
      branch_id: "station_to",
      name: "station_to_name",
    },
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
      Enter: "consignor_name",
    },
    valueVerificationFromSuggestionNeeded: true,
    valueVerificationCompulsionField: "station_to",
  };

  let consigneeNameFieldInfo = {
    label: "Consignee Name",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignee_name",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsigneeSuggestions",
    url: SERVER_URL + "/station_to_map/bilty_consignee",
    suggestionMethodType: "GET",
    suggestionKeyword: "consignee_name",
    suggestionKeywordExtra: "consignee_gst",
    suggestionKeywordForFetchApiArgs: "search",
    suggestionChooseQueryKeyword: "consignee_id",
    suggestionSchema: {
      consignee_name: "consignee_name",
      consignee_id: "consignee",
      consignee_gst: "consignee_gst",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "[a-zA-z]",
    keyboardNavigationMap: {
      Enter: "consignee_gst",
    },
    idClearanceNeeded: "consignee_id",
    inputDataNeededInSuggestions: false,
    inputDataFilter: {
      pay_type: "same",
    },
  };

  let consigneeGstFieldInfo = {
    label: "Consignee GST",
    className: "form-row",
    labelClassName: "form-label",
    inputClassName: "form-input",
    name: "consignee_gst",
    type: "text",
    placeHolder: "",
    apiConfigKey: "getConsigneeSuggestions",
    url: SERVER_URL + "/station_to_map/consignees",
    suggestionMethodType: "GET",
    suggestionKeyword: "consignee_gst",
    suggestionKeywordExtra: "consignee_name",
    suggestionKeywordForFetchApiArgs: "search",
    suggestionChooseQueryKeyword: "consignee_id",
    suggestionSchema: {
      consignee_name: "consignee_name",
      consignee_gst: "consignee_gst",
      consignee_id: "consignee",
    },
    apiCallRequiredOnGetValue: true,
    toValidate: true,
    regExpValidation: "^[0-9A-Z]{15}$",
    keyboardNavigationMap: {
      Enter: "station_to_name",
    },
    idClearanceNeeded: "consignee_id",
  };

  const linkBilty = (e) => {
    if (e.key == "Enter") {
      const hasConsignee =
        (myForm.pageState.consignee_name ?? "").trim() != "" ||
        (myForm.pageState.consignee ?? "") != "";
      if (hasConsignee && myForm.pageState.station_to != "") {
        let dummyObject = {
          consignor_id: myForm.pageState.consignor_id,
          consignor_name: myForm.pageState.consignor_name,
          consignee_id: myForm.pageState.consignee,
          consignee: myForm.pageState.consignee,
          consignee_name: myForm.pageState.consignee_name,
          consignee_gst: myForm.pageState.consignee_gst,
          station_to: myForm.pageState.station_to,
          station_to_name: myForm.pageState.station_to_name,
        };
        let currentRateInfo = [...(myForm.pageState.rate_info ?? [])];
        if (editingRateInfoIndexRef.current !== null) {
          // ensure we replace at same position logic not critical; just append updated row
          currentRateInfo.push(dummyObject);
        } else {
          currentRateInfo.push(dummyObject);
        }
        let objectToSave = {
          rate_info: currentRateInfo,
          station_to: "",
          station_to_name: "",
          consignee: "",
          consignee_name: "",
          consignee_gst: "",
        };
        myForm.setPageState({
          ...myForm.pageState,
          ...objectToSave,
        });
        editingRateInfoIndexRef.current = null;
        myForm.makeFocusOnParticularField("station_to_name");
        return;
      }
      myForm.makeFocusOnParticularField("save_button");
    }
  };

  const checkDisabledCondition = (fieldInfo) => {
    if (myForm.pageMode == "view") {
      return "disabled";
    }
    return "";
  };

  const rateInfo = myForm.pageState.rate_info ?? [];
  const searchTerm = tableSearch.trim().toLowerCase();
  const filteredRateInfo = searchTerm
    ? rateInfo.filter((row) =>
        [
          "consignor_name",
          "consignee_name",
          "consignee_gst",
          "station_to_name",
        ].some((key) =>
          String(row[key] ?? "")
            .toLowerCase()
            .includes(searchTerm),
        ),
      )
    : rateInfo;
  const getRateInfoIndex = (idx) => rateInfo.indexOf(filteredRateInfo[idx]);

  const handleEditSpecificRow = (idx, fieldMapping) => () => {
    const rows = [...myForm.pageState[fieldMapping]];
    const actualIdx =
      fieldMapping === "rate_info" ? getRateInfoIndex(idx) : idx;
    if (actualIdx < 0) {
      return;
    }
    let dct = rows[actualIdx];
    if (
      (myForm.pageState.station_to != "" || myForm.pageState.station_to_name != "") &&
      myForm.pageState.consignee != "" &&
      editingRateInfoIndexRef.current !== actualIdx
    ) {
      myForm.setPageMode("error");
      myForm.setPopupError("Clear Or Update existing Entry");
      return;
    }
    // Remove the row being edited so it doesn't create duplicate when added back
    rows.splice(actualIdx, 1);
    editingRateInfoIndexRef.current = actualIdx;

    let mappedDct = {
      ...dct,
      station_to: dct.station_to ?? "",
      station_to_name: dct.station_to_name ?? "",
      consignee: dct.consignee_id ?? dct.consignee ?? "",
      consignee_name: dct.consignee_name ?? "",
      consignee_gst: dct.consignee_gst ?? "",
    };
    myForm.setPageState({ ...myForm.pageState, ...mappedDct, rate_info: rows });

    if (myForm.deleteEntryFromTableCallback != null) {
      myForm.deleteEntryFromTableCallback({ idx: actualIdx, rows: rows });
      return;
    }
  };

  const handleDeleteTableRow = ({ idx }) => {
    const actualIdx = getRateInfoIndex(idx);
    if (actualIdx < 0) {
      return;
    }
    const rows = [...rateInfo];
    rows.splice(actualIdx, 1);
    myForm.setPageStateByField("rate_info", rows);
  };

  const handleDelete = async () => {
    const consignorId = getConsignorId();
    if (consignorId == "" || consignorId == null) {
      myForm.setPageMode("error");
      myForm.setPopupError("Select a valid Consignor first");
      return;
    }
    if (
      myForm.pageState.rate_info == null ||
      myForm.pageState.rate_info.length == 0
    ) {
      myForm.setPageMode("error");
      myForm.setPopupError("No data to delete");
      return;
    }
    myForm.setOverlay(true);
    const url =
      SERVER_URL + "/station_to_map/?consignor_id=" + String(consignorId);
    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
        },
      });
      if (!response.ok) {
        myForm.setPageMode("error");
        myForm.setPopupError("Failed to delete station mappings");
        return;
      }
      myForm.setPageState({
        ...myForm.pageState,
        rate_info: [],
        station_to: "",
        station_to_name: "",
        consignee: "",
        consignee_name: "",
        consignee_gst: "",
      });
      myForm.makeFocusOnParticularField("consignee_name");
    } catch (err) {
      console.log("Error in station_to_map delete", err);
      myForm.setPageMode("error");
      myForm.setPopupError("Failed to delete station mappings");
    } finally {
      myForm.setOverlay(false);
    }
  };

  return (
    <div className="challan-form-container">
      <LoadingOverlay
        active={myForm.overlay}
        spinner
        text="Loading..."
        styles={{
          wrapper: {
            overflow: "hidden",
          },
        }}
      />
      <div>
        <div>
          <Popup
            open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            {(close) => (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  {" "}
                  {myForm.pageMode == "submitted" ? (
                    <div>{popupInfo.success_header}</div>
                  ) : (
                    <div>{popupInfo.error_header}</div>
                  )}
                  <div>
                    <a className="pop-up-close btn" onClick={close}>
                      &times;
                    </a>
                  </div>
                </div>
                {myForm.pageMode == "submitted" ? (
                  <div className="pop-up-content">
                    {popupInfo.success_title}
                    <br />
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <div className="pop-up-field-label">
                          {popupInfo.field_label_success}
                        </div>
                        <div className="pop-up-field-value">
                          {myForm.pageState[popupInfo.field_name_success]}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="pop-up-content">
                    {popupInfo.error_title}
                    <br />
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <div className="pop-up-field-label">
                          {popupInfo.field_label_error}
                        </div>
                        <div className="pop-up-field-value">
                          {myForm.popupError}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="pop-up-actions">
                   <button
                     className="pop-up-button"
                     onClick={() => {
                       if (myForm.pageMode == "submitted") {
                         const savedList = myForm.submitApiState?.data?.response?.saved;
                         let saved =
                           Array.isArray(savedList) && savedList.length
                             ? savedList[savedList.length - 1]
                             : null;
                         if (!saved && Array.isArray(myForm.pageState.rate_info) && myForm.pageState.rate_info.length) {
                           const lastRow =
                             myForm.pageState.rate_info[myForm.pageState.rate_info.length - 1];
                           saved = {
                             consignee_id: lastRow.consignee_id ?? lastRow.consignee,
                             consignee_name: lastRow.consignee_name,
                             consignee_gst: lastRow.consignee_gst,
                             station_to: lastRow.station_to,
                           };
                         }
                         if (typeof onSaved === "function") {
                           onSaved(saved);
                         }
                         myForm.setPageState({
                           ...dataObject,
                           ...variablesFromSession,
                         });
                         myForm.setPageMode("write");
                         close();
                       } else {
                         myForm.setPageMode("write");
                         close();
                       }
                     }}
                   >
                    Okay
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
      </div>

      <div className="form-header">Consignee Station Master</div>
      <div onSubmit={myForm.handleSubmit} className="form" noValidate>
        <div className="form-input-content-block-0"></div>
        <div className="chform-row">
          <div style={{ display: "flex" }}>
            <label className="chform-label">Consignor Name</label>
            <div className="chform-input">
              <select
                className="form-input"
                value={myForm.pageState.consignor_id || ""}
                onChange={async (e) => {
                  const selectedId = e.target.value;
                  if (!selectedId) {
                    selectedConsignorIdRef.current = "";
                    myForm.setPageStateByField("consignor_id", "");
                    myForm.setPageStateByField("consignor_name", "");
                    myForm.setPageStateByField("rate_info", []);
                    return;
                  }
                  const selected = consignorOptions.find(
                    (c) => c.id === selectedId,
                  );
                  if (!selected) return;
                  selectedConsignorIdRef.current = selected.id;
                  myForm.setPageStateByField("consignor_id", selected.id);
                  myForm.setPageStateByField("consignor_name", selected.name);
                  await fetchStationToMapByConsignor(selected.id);
                  myForm.makeFocusOnParticularField("consignee_name");
                }}
                disabled={checkDisabledCondition(consignorNameFieldInfo)}
              >
                <option value="">Select a party or consignor</option>
                {consignorOptions.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name} - {c.gst}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <label className="chform-label">Consignee Name</label>
            <div className="chform-input">
              <Autosuggest
                id={consigneeNameFieldInfo["name"]}
                suggestions={
                  myForm.suggestions != undefined ? myForm.suggestions : ""
                }
                onSuggestionsFetchRequested={(a) =>
                  myForm.onSuggestionsFetchRequestedDebounced(a, (b) =>
                    myForm.suggestionFetchApi(consigneeNameFieldInfo, b),
                  )
                }
                onSuggestionsClearRequested={() =>
                  myForm.onSuggestionsClearRequested(consigneeNameFieldInfo)
                }
                getSuggestionValue={(suggestion) =>
                  suggestion[consigneeNameFieldInfo.suggestionKeyword]
                }
                onSuggestionSelected={(a, b) => {
                  const consigneeId =
                    b.suggestion?.consignee_id || b.suggestion?.consignee || "";
                  myForm.setPageStateByField(
                    "consignee_gst",
                    b.suggestion?.consignee_gst ?? "",
                  );
                  myForm.setPageStateByField("consignee", consigneeId);
                  myForm.setPageStateByField("consignee_id", consigneeId);
                  myForm.getSuggestionValue(
                    b.suggestion,
                    consigneeNameFieldInfo,
                    myForm.performSuggestions,
                    myForm.updatePageStateForGetSuggestion,
                  );
                }}
                renderSuggestion={(a) =>
                  myForm.renderSuggestion(a, consigneeNameFieldInfo)
                }
                highlightFirstSuggestion={true}
                ref={(a) => myForm.storeInputReference(a, false)}
                inputProps={{
                  value: String(
                    myForm.pageState[consigneeNameFieldInfo["name"]],
                  ),
                  onChange: (a, b) => {
                    if (b.method !== "type") {
                      myForm.onChangeAutoSuggest(a, b, consigneeNameFieldInfo);
                      return;
                    }
                    if (!b.suggestion) {
                      /**
                       * Value is not picked from the suggestion api, so the
                       * consignee id can not be trusted anymore. Name and gst
                       * typed manually are kept as it is.
                       */
                      myForm.setPageStateByField("consignee", "");
                    }
                    myForm.onChangeAutoSuggest(a, b, consigneeNameFieldInfo);
                  },

                  onBlur: () => {
                    consigneeNameFieldInfo["toValidate"]
                      ? myForm.onblurValidator(consigneeNameFieldInfo)
                      : {};
                  },
                  onKeyPress: async (a) => {
                    if (a.key === "Enter") {
                      const consigneeId =
                        myForm.pageState.consignee || myForm.pageState.consignee_id;
                      // If user typed/selected consignee, fetch by consignee and override
                      if (consigneeId) {
                        await fetchStationToMapByConsignee(consigneeId);
                        myForm.makeFocusOnParticularField("consignee_gst");
                        return;
                      }
                    }
                    getConsigneeStation(a);
                  },
                  disabled: checkDisabledCondition(consigneeNameFieldInfo),
                }}
              />
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <label className="chform-label">Consignee GST</label>
            <div className="chform-input">
              <Autosuggest
                id={consigneeGstFieldInfo["name"]}
                suggestions={
                  myForm.suggestions != undefined ? myForm.suggestions : ""
                }
                onSuggestionsFetchRequested={(a) =>
                  myForm.onSuggestionsFetchRequestedDebounced(a, (b) =>
                    myForm.suggestionFetchApi(consigneeGstFieldInfo, b),
                  )
                }
                onSuggestionsClearRequested={() =>
                  myForm.onSuggestionsClearRequested(consigneeGstFieldInfo)
                }
                getSuggestionValue={(suggestion) =>
                  suggestion[consigneeGstFieldInfo.suggestionKeyword]
                }
                onSuggestionSelected={(a, b) => {
                  const consigneeId =
                    b.suggestion?.consignee_id || b.suggestion?.consignee || "";
                  myForm.setPageStateByField(
                    "consignee_name",
                    b.suggestion?.consignee_name ?? "",
                  );
                  myForm.setPageStateByField("consignee", consigneeId);
                  myForm.setPageStateByField("consignee_id", consigneeId);
                  myForm.getSuggestionValue(
                    b.suggestion,
                    consigneeGstFieldInfo,
                    myForm.performSuggestions,
                    myForm.updatePageStateForGetSuggestion,
                  );
                }}
                renderSuggestion={(a) =>
                  myForm.renderSuggestion(a, consigneeGstFieldInfo)
                }
                highlightFirstSuggestion={true}
                ref={(a) => myForm.storeInputReference(a, false)}
                inputProps={{
                  value: String(
                    myForm.pageState[consigneeGstFieldInfo["name"]] ?? "",
                  ),
                  onChange: (a, b) => {
                    if (b.method !== "type") {
                      myForm.onChangeAutoSuggest(a, b, consigneeGstFieldInfo);
                      return;
                    }
                    if (!b.suggestion) {
                      /**
                       * Value is not picked from the suggestion api, so the
                       * consignee id can not be trusted anymore. Name and gst
                       * typed manually are kept as it is.
                       */
                      myForm.setPageStateByField("consignee", "");
                    }
                    let value = a.target.value || "";
                    value = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                    if (value.length > 15) {
                      value = value.substring(0, 15);
                    }
                    a.target.value = value;
                    myForm.onChangeAutoSuggest(a, b, consigneeGstFieldInfo);
                  },
                  onBlur: () => {
                    if (consigneeGstFieldInfo["toValidate"]) {
                      const gst = String(
                        myForm.pageState[consigneeGstFieldInfo["name"]] || "",
                      )
                        .trim()
                        .toUpperCase();
                      if (gst && !/^[0-9A-Z]{15}$/.test(gst)) {
                        myForm.setPageMode("error");
                        myForm.setPopupError("GSTIN Must be 15 alphanumeric characters");
                        return;
                      }
                      if (gst) {
                        myForm.setPageStateByField("consignee_gst", gst);
                      }
                      myForm.onblurValidator(consigneeGstFieldInfo);
                    }
                  },
                  onKeyPress: (a) =>
                    myForm.onKeyPressForKeyNav(a, consigneeGstFieldInfo),
                  disabled: checkDisabledCondition(consigneeGstFieldInfo),
                }}
              />
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <label className="chform-label">Station To</label>
            <div className="chform-input">
              <Autosuggest
                id={stationToFieldInfo["name"]}
                suggestions={
                  myForm.suggestions != undefined ? myForm.suggestions : ""
                }
                onSuggestionsFetchRequested={(a) =>
                  myForm.onSuggestionsFetchRequested(a, (b) =>
                    myForm.suggestionFetchApi(stationToFieldInfo, b),
                  )
                }
                onSuggestionsClearRequested={() =>
                  myForm.onSuggestionsClearRequested(stationToFieldInfo)
                }
                getSuggestionValue={(suggestion) =>
                  suggestion[stationToFieldInfo.suggestionKeyword]
                }
                onSuggestionSelected={(a, b) =>
                  myForm.getSuggestionValue(
                    b.suggestion,
                    stationToFieldInfo,
                    myForm.performSuggestions,
                    myForm.updatePageStateForGetSuggestion,
                  )
                }
                renderSuggestion={(a) =>
                  myForm.renderSuggestion(a, stationToFieldInfo)
                }
                highlightFirstSuggestion={true}
                ref={(a) => myForm.storeInputReference(a, false)}
                inputProps={{
                  value: String(myForm.pageState[stationToFieldInfo["name"]]),
                  onChange: (a, b) => {
                    myForm.onChangeAutoSuggest(a, b, stationToFieldInfo);
                  },
                  onBlur: () => {
                    stationToFieldInfo["toValidate"]
                      ? myForm.onblurValidator(stationToFieldInfo)
                      : {};
                  },
                  onKeyPress: linkBilty,
                  disabled: checkDisabledCondition(stationToFieldInfo),
                }}
              />
            </div>
          </div>
        </div>

        <input
          type="text"
          className="form-input"
          placeholder="Search in table..."
          value={tableSearch}
          onChange={(e) => setTableSearch(e.target.value)}
          style={{
            marginBottom: "10px",
            maxWidth: "250px",
            marginLeft: "15px",
          }}
        />
        <div className="table-container">
          <DynamicViewTable
            edit={1}
            delete={1}
            editRowFunction={handleEditSpecificRow}
            tableHeader={consigneeStationTableHeader}
            tableItems={consigneeStationTableItems}
            tableValues={filteredRateInfo}
            setPageStateByField={myForm.setPageStateByField}
            pageStateArray={myForm.pageState["rate_info"]}
            fieldMapping="rate_info"
            deleteEntryFromTableCallback={handleDeleteTableRow}
          />
        </div>
        <div className="form-footer">
          <button
            onClick={(e) => {
              if (
                !myForm.pageState.rate_info ||
                myForm.pageState.rate_info.length == 0
              ) {
                myForm.setPageMode("error");
                myForm.setPopupError("No data to save");
                return;
              }
              try {
                myForm.setOverlay && myForm.setOverlay(true);
              } catch (err) {}
              myForm.handleSubmit(e);
            }}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          <button onClick={handleDelete} className="btn btn-primary">
            Delete All
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsigneeStationMasterForm;
